import './_vportal.js';

window.addEventListener("load", function () {
  var bannerEl = document.querySelector('.swiper-news-banner');
  if (bannerEl) {
    new Swiper(bannerEl, {
      effect: "fade",
      fadeEffect: { crossFade: true },
      // Mobile-first: show pagination bullets, hide arrows
      pagination: {
        el: ".swiper-news-banner-pagination",
        clickable: true,
        enabled: true,
      },
      navigation: {
        nextEl: ".swiper-news-banner-next",
        prevEl: ".swiper-news-banner-prev",
        enabled: false,
      },
      // Switch to arrows on larger screens
      breakpoints: {
        769: {
          pagination: {
            enabled: false,
          },
          navigation: {
            nextEl: ".swiper-news-banner-next",
            prevEl: ".swiper-news-banner-prev",
            enabled: true,
          },
        },
      },
    });
  }

  $(".news").each(function () {
    var postsTag = "#" + $(this).attr("id");
    $().vPortal({
      container: postsTag,
      el: {
        tabContainer: '.news-tabs > a',
        resultContainer: '.news-list',
        viewAll: '.viewAll',
      },
      paginationOptions: {
      }
    });

  });
});